/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CreateLeadCapturePopupCancelIcon from "../../../../assets/icons/CreateLeadCapturePopupCancelIcon.svg";
import CloseIcon from "../../../../assets/icons/closeIcon.svg";
import { mergeExactLeadDetails } from "../../../../api/lead";
import "./lead-qualification-merge-confirmation-popups.scss";

const LeadQualificationMergeConfirmationPopups= (props: any) => {
   const {
        setIsShowConfirmMergePopup,
        isShowConfirmMergePopup,
        setLoading, 
        setAlertMessage, 
        setAlertType,  
        setAlertOpen,
        selectedLeadId,
        fetchLeads,
        setSelectedLeadId
  } = props;
    const handleConfirmMerge = async () => {
          setLoading(true);
        try {
            const response = await mergeExactLeadDetails({ 'leadIds': selectedLeadId, matchingCriteria: 'Exact' });
            if (response?.status === 200) {
                setAlertMessage(`Lead duplicates merged successfully`);
                setAlertType("success");
                setAlertOpen(true);
                setSelectedLeadId([]);
                setIsShowConfirmMergePopup(false);
                fetchLeads();
            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message ||  "An error occurred while saving the lead.");
            setAlertType("error");
            setAlertOpen(true);
            setIsShowConfirmMergePopup(false);
        } finally {
            setLoading(false);
            setAlertOpen(true);
            setIsShowConfirmMergePopup(false);
        }
    };

  return (
    <>
     <Dialog
        open={isShowConfirmMergePopup}
        // onClose={() => setIsShowConfirmMergePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`create-lead-capture-popup-cancel`}
      >
        <DialogTitle id="alert-dialog-title">
            <div className="header-wrapper">
              <div className="image-wrapper">
              <div className="title-with-icon">
                <img src={CreateLeadCapturePopupCancelIcon} className="delete-icon"></img>
                <div>{'Confirm Merge'}</div>
              </div>
                <img
                  src={CloseIcon}
                  className="close-icon"
                  onClick={() => setIsShowConfirmMergePopup(false)}
                />
              </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="cancel-popup-sub-text">
              You're about to merge all selected exact duplicates into single records. This action cannot be undone. Are you sure you want to proceed?
            </div>
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() =>setIsShowConfirmMergePopup(false)} className="cancel-btn">
            Cancel
          </Button>
          <Button onClick={handleConfirmMerge} autoFocus className="action-btn">
            Confirm Merge
          </Button>
        </DialogActions>
      </Dialog>          
    </>
  );
}

export default LeadQualificationMergeConfirmationPopups;
